import { Container } from './styles';

interface IProps {
  placeholder: string;
}

export const StyledTextarea = ({ placeholder }: IProps) => (
  <Container placeholder={placeholder} />
);
